import { Column } from 'react-table'
import GetUrls from 'ts/enums/Url'
import { SubClass } from 'ts/types/SubClass'
import CardTable from 'components/CardTable'
import { Boolean as BooleanCell } from 'components/ui'
import SubClassAddPage from './SubClassAddPage'
import useFetchSafe from 'hooks/useFetchSafe'

const SubClassPage = () => {
  const Url = GetUrls();
  const ClassOpt = useFetchSafe(Url.getClass)
  const optionList = (ClassOpt as any).data;

  const columns: Column<SubClass>[] = [
    {
      Header: 'ID',
      accessor: 'subclassId'
    },
    {
      Header: 'Active',
      accessor: 'flActive',
      Cell: ({ value }) => <BooleanCell value={value} />
    },
    {
      Header: 'Sub Class Name',
      accessor: 'name'
    },
    {
      Header: 'Class Name',
      accessor: 'classId',
      Cell: ({ value }) => {
        const classNameObj = value && optionList ? optionList.find(
          (item: { classId: number }) => item.classId === value) 
          : { name:"" };
        return (
          classNameObj && value ? classNameObj?.name : "..."
        ) 
      }
    }
  ]

  return (
    columns && optionList &&
      <CardTable
        columns={columns}
        dataKey={Url.getSubclass.toString()}
        url={Url.getSubclass}
        modalChild={<SubClassAddPage />}
      />
  )
}


export default SubClassPage
